import {FIELD_ORDER_UI_SCHEMA_KEY, ShapeUISchemaV2NestedShapeValues} from '../../StepConfigEditorTypes';

/**
 * Heatmap configuration sections for the Configure tab
 */
export const HEATMAP_CONFIG_SECTIONS = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['configSection'],
  configSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['rows', 'columns', 'metric', 'gradientDirection'],
    rows: {
      displayName: 'Y-axis',
      configShapePath: ['chartConfig', 'parameters', 'yAxisColumnName'],
    },
    columns: {
      displayName: 'Rows',
      configShapePath: ['chartConfig', 'parameters', 'xAxisColumnName'],
    },
    metric: {
      displayName: 'Metric',
      configShapePath: ['chartConfig', 'parameters', 'metricColumnName'],
    },
    gradientDirection: {
      displayName: 'Gradient direction',
      configShapePath: ['chartConfig', 'parameters', 'gradientDirection'],
      fieldSettings: {
        displayNames: {
          ASCENDING_METRIC_VALUES: 'Ascending',
          DESCENDING_METRIC_VALUES: 'Descending',
        },
      },
    },
  },
} as const satisfies ShapeUISchemaV2NestedShapeValues;
